"use client";

import React from "react";
import Image from "next/image";
// import chefImg from "@/assets/whymsu/Mask group (3).png";
import { ArrowUpRight } from "lucide-react";
const chefImg = "https://cdn.msu.edu.in/msu-reavamp/banner/our-leader.jpg";
const Leadershipwhoweare = () => {
    return (
        <section className="w-full bg-[#0475B3] ">
            <div className="page-container py-10">
                <div className="w-full">
                    <div className="grid grid-cols-1  xl:grid-cols-[1fr_1fr]">


                        <div className=" text-white px-6 md:px-14 py-10 md:py-16 flex flex-col justify-between order-2">
                            <div className="max-w-xl space-y-4">
                                <h5
                                    style={{ fontFamily: "saans-bold" }}
                                    className="text-white text-xl md:text-[42px]">
                                    Our Leadership
                                </h5>
                                <p
                                    className="text-[11px] md:text-[16px] leading-relaxed"
                                    style={{ fontFamily: "saans-regular" }}
                                >
                                Our leadership, led by visionary educators Shri Pravesh Dudani, IIT Kharagpur alumnus and Stanford 
                                graduate with global business insight, and Shri Kuldip Sarma, a transformative leader championing 
                                youth empowerment, driving higher education initiatives, stands behind every dream at MSU. Guided by 
                                vision, empathy and an unwavering belief in education’s power to transform lives, 
                                our leaders and the University are a ‘pioneering force in driving nation-building through skill-integrated education’.                                </p>
                            </div>

                            <button onClick={() => window.open("/leadership")}
                                className="group mt-6 inline-flex items-center cursor-pointer w-[200px] justify-center bg-[#081E2D] text-white text-[11px] md:text-sm font-medium px-4 py-2 md:px-4 md:py-3"
                                style={{ fontFamily: "saans-bold" }}
                            >
                                <span>Know more</span>
                                <ArrowUpRight
                                    className="ml-2 rotate-45 group-hover:-rotate-0 h-6 w-6  transition-transform duration-300 "
                                    strokeWidth={2.2}
                                />
                            </button>
                        </div>
                        <div className="relative h-[300px]  md:mt-10 p-10 sm:h-[300px] md:h-[500px] bg-slate-200 order-1 md:order-2">
                            <Image
                                src={chefImg}
                                alt="Pavesh Dudani and Kuldeep Sharma"
                                fill
                                className="object-cover"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Leadershipwhoweare;